import React, { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// 동적 import로 각 폴더의 OtpPage 로드
const AdminOtpPage = lazy(() => import('../../Admin/Pages/Login/OtpPage').catch(() => ({ default: () => <Navigate to="/cp/login" replace /> })));
const MerchantOtpPage = lazy(() => import('../../Merchant/Pages/Login/OtpPage').catch(() => ({ default: () => <Navigate to="/app/login" replace /> })));

/**
 * 로그인 후 OTP 페이지: 미로그인 → 로그인으로, OTP 완료됨 → 대시보드로, 그 외 → OTP 페이지
 */
function OtpGateRoute({ loginPath, dashboardPath, userType }) {
  const isLoggedIn = useSelector((state) => state.login.value);
  const otpVerified = useSelector((state) => state.login.otpVerified);

  if (!isLoggedIn) {
    return <Navigate to={loginPath} replace />;
  }
  if (otpVerified) {
    return <Navigate to={dashboardPath} replace />;
  }

  const OtpPageComponent = userType === 'admin' ? AdminOtpPage : MerchantOtpPage;

  return (
    <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>로딩 중...</div>}>
      <OtpPageComponent
        basePath={loginPath}
        dashboardPath={dashboardPath}
      />
    </Suspense>
  );
}

export default OtpGateRoute;
